import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FormatDate {

    formatDate(date: string | Date): Date | null {

        if (typeof date === 'string') {

            return new Date(date + 'T00:00:00-03:00'); // Append time to ensure correct parsing
        } else if (date instanceof Date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0); // Reset time to midnight
        } else {
            return null; // Return null if the input is neither a string nor a Date object
        }

    }

}

export function transformDateYYYYMMDD(date: Date): string {
    const newDateStart = new Date(date);
    return newDateStart.getFullYear().toString() + "-" +
        (("0") + (newDateStart.getMonth() + 1)).toString().slice(-2) + "-" +
        (("0") + newDateStart.getDate()).toString().slice(-2);
}